import { useState, useEffect, useCallback } from 'react';
import { tareaService } from '../services/supabase';

export function useTareas(usuarioId, campoId) {
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTareas = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await tareaService.getAll(usuarioId, campoId);
      setTareas(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando tareas:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  useEffect(() => {
    loadTareas();
  }, [loadTareas]);

  const createTarea = useCallback(async (tarea) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await tareaService.create(usuarioId, campoId, tarea);
      setTareas(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  const updateTarea = useCallback(async (tareaId, updates) => {
    try {
      const updated = await tareaService.update(tareaId, updates);
      setTareas(prev => prev.map(t => t.id === tareaId ? updated : t));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  const deleteTarea = useCallback(async (tareaId) => {
    try {
      await tareaService.delete(tareaId);
      setTareas(prev => prev.filter(t => t.id !== tareaId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    tareas,
    setTareas,
    loading,
    error,
    loadTareas,
    createTarea,
    updateTarea,
    deleteTarea,
  };
}
